/* coberturaPresets.js — Coverage plan presets (Plan 50/60/70) */

let _idCounter = 0;
export const createUid = (prefix) => `${prefix}_${(++_idCounter).toString(36)}`;

function makePlan(pct) {
  const noco = Math.round(pct / 2);
  const cReemb  = createUid('cg');
  const cTope   = createUid('cg');
  const colPref  = createUid('c');
  const colBono  = createUid('c');
  const colLibre = createUid('c');
  const colNoCob = createUid('c');
  const colUnit  = createUid('c');
  const colAnual = createUid('c');

  const columnGroups = [
    {
      id: cReemb,
      name: '% Reembolso',
      columns: [
        { id: colPref,  name: 'Prest. preferente', sub: '(a)', align: 'center' },
        { id: colBono,  name: 'Bono',               align: 'center' },
        { id: colLibre, name: 'Libre elección', sub: '(Reembolso)', align: 'center' },
        { id: colNoCob, name: 'Sin cobertura',  sub: '(b)', align: 'center' },
      ],
    },
    {
      id: cTope,
      name: 'Tope coberturas UF',
      columns: [
        { id: colUnit,  name: 'Unidad', align: 'center' },
        { id: colAnual, name: 'Anual',  align: 'center' },
      ],
    },
  ];

  const P = `${pct}%`;
  const N = `${noco}%`;
  const F = '100%';
  const D = '—';

  const r = (name, vals) => ({
    id: createUid('r'),
    name,
    cells: {
      [colPref]:  vals[0] ?? '',
      [colBono]:  vals[1] ?? '',
      [colLibre]: vals[2] ?? '',
      [colNoCob]: vals[3] ?? '',
      [colUnit]:  vals[4] ?? '',
      [colAnual]: vals[5] ?? '',
    },
  });

  const matBono  = pct === 60 ? F : P;
  const matLibre = pct === 60 ? F : P;
  const matNo    = pct === 60 ? '50%' : N;

  const rowGroups = [
    {
      id: createUid('rg'),
      name: 'Ambulatorio',
      rows: [
        r('Consulta a domicilio',                      [D, P, P, N, 'UF 0,6', 'Sin tope']),
        r('Consulta de especialista',                  [D, P, P, N, 'UF 0,6', 'Sin tope']),
        r('Consulta general',                          [D, P, P, N, 'UF 0,6', 'Sin tope']),
        r('Consulta médico de urgencia',               [D, P, P, N, 'UF 1',   'Sin tope']),
        r('Exámenes de imagenología ambulatorios',     [D, P, P, N, '',       'Sin tope']),
        r('Exámenes de laboratorio ambulatorios',      [D, P, P, N, '',       'Sin tope']),
        r('Fonoaudiología',                            [D, P, P, N, '',       'Sin tope']),
        r('Kinesiología',                              [D, P, P, N, '',       'Sin tope']),
        r('Terapeuta ocupacional',                     [D, P, P, N, 'UF 0,6', 'UF 10']),
        r('Nutricionista',                             [D, P, P, N, 'UF 0,6', 'UF 10']),
        r('Medicamentos bioequivalentes (*)',           [D, '70%', '70%', '70%', 'UF 1/mes', 'Sin tope']),
        r('Medicamentos genéricos (*)',                [D, F,     F,     F,     'UF 1/mes', 'Sin tope']),
        r('Medicamentos de marca (*)',                 [D, '60%', '60%', '60%', 'UF 1/mes', 'Sin tope']),
        r('Procedimientos diagnóstico ambulatorios',   [D, P, P, N, '', 'Sin tope']),
        r('Procedimientos terapéuticos ambulatorios',  [D, P, P, N, '', 'Sin tope']),
        r('Cirugía ambulatoria',                       [D, P, P, N, '', 'Sin tope']),
      ],
    },
    {
      id: createUid('rg'),
      name: 'Hospitalario',
      rows: [
        r('Convenio día cama',                                [F, P, P, N, 'UF 3', 'Sin tope']),
        r('Honorarios médicos',                               [F, P, P, N, '',     'Sin tope']),
        r('Servicios hospitalarios (lab. / pabellón)',        [F, P, P, N, '',     'Sin tope']),
        r('Cirugía dental por accidente o enfermedad',        [F, P, P, N, '',     'Sin tope']),
        r('Cirugía maxilofacial',                             [pct === 70 ? F : D, P, P, N, '', 'Sin tope']),
        r('Servicio privado de enfermería (hospitalario)',    [F, P, P, N, '',     'Sin tope']),
        r('Día cama incubadora',                              [F, P, P, N, '',     'UF 15']),
        r('Día cama intermedio',                              [F, P, P, N, '',     'UF 15']),
        r('Día cama UTI / UCI',                               [F, P, P, N, '',     'UF 25']),
        r('Gasto donante vivo / post mortem',                 [D, P, P, N, '',     'UF 20']),
        r('Día cama Home Care',                               [D, P, P, N, 'UF 3', 'Sin tope']),
        r('Día cama acompañantes (hijo ≤14 años)',            [D, P, P, N, 'UF 2', 'Sin tope']),
      ],
    },
    {
      id: createUid('rg'),
      name: 'Maternidad',
      rows: [
        r('Parto múltiple',                      [D, matBono, matLibre, matNo, '', 'UF 30']),
        r('Aborto natural',                      [D, matBono, matLibre, matNo, '', 'UF 10']),
        r('Cesárea',                             [D, matBono, matLibre, matNo, '', 'UF 25']),
        r('Complicaciones del embarazo / parto', [D, pct === 60 ? '70%' : P, pct === 60 ? '70%' : P, pct === 60 ? '35%' : N, '', 'UF 10']),
        r('Parto normal',                        [D, matBono, matLibre, matNo, '', 'UF 15']),
      ],
    },
    {
      id: createUid('rg'),
      name: 'Otros gastos',
      rows: [
        r('Prótesis (ambulatoria · hospitalaria)',           [D, P, P, N, '', 'UF 20']),
        r('Marcos / cristales / lentes de contacto',        [D, P, P, N, '', 'UF 5']),
        r('Órtesis (ambulatoria · hospitalaria)',           [D, P, P, N, '', 'UF 20']),
        r('Plantillas',                                     [D, P, P, N, '', '']),
        r('Cirugía ocular (mayor a 5 dioptrías)',           [D, P, P, N, '', 'UF 20']),
        r('Tratamiento obesidad mórbida (IMC > 40)',        [D, P, P, N, '', 'UF 20']),
        r('Arriendo de equipos ambulatorios',               [D, P, P, N, '', 'UF 50']),
        r('Aparatos auditivos',                             [D, P, P, N, '', 'UF 10']),
        r('Materiales de venda de yeso',                    [D, P, P, N, '', 'Sin tope']),
      ],
    },
    {
      id: createUid('rg'),
      name: 'Salud mental',
      rows: [
        r('Sesión psicológica',           [D, P, P, N, 'UF 1', 'UF 12']),
        r('Sesión psicopedagogo',         [D, P, P, N, 'UF 1', 'UF 12']),
        r('Sesión psiquiátrica',          [D, P, P, N, 'UF 1', 'UF 12']),
        r('Hospitalización psiquiátrica', [D, P, P, N, '', '']),
      ],
    },
    {
      id: createUid('rg'),
      name: 'Preventivo',
      rows: [
        r('Ginecología (PAP / mamografía / consulta)',       [D, F, F, '', '', 'UF 5']),
        r('Urología (PSA — antígeno prostático / consulta)', [D, F, F, '', '', 'UF 5']),
      ],
    },
    {
      id: createUid('rg'),
      name: 'Ambulancia',
      rows: [
        r('Servicio de ambulancia aérea',    [D, P, P, N, '', 'UF 20']),
        r('Servicio de ambulancia terrestre',[D, P, P, N, '', 'UF 5']),
      ],
    },
  ];

  return {
    title: `Plan ${pct}% — Divina Seguros`,
    eyebrow: 'Cuadro de coberturas',
    subtitle: `Cobertura complementaria de salud · Pol. 320150700 · Vigencia 2026`,
    footnotes: [
      'a) Atenciones en centros médicos hospitalarios públicos (Isapre / Fonasa).',
      'b) A excepción de lo indicado en el Artículo n° 8 — Exclusiones, Condicionado General POL320150700.',
      'c) Para nuevos asegurados, las preexistencias evaluadas son: cáncer, cardiopatía, diabetes, enfermedades vasculares, enfermedades renales y escoliosis severa. Desde el mes 13 se elimina la condición de preexistencia.',
      '(*) Medicamentos incluyen inmunosupresores / inmunomoduladores y antineoplásicos (cáncer).',
    ],
    columnGroups,
    superGroups: [{ id: createUid('sg'), name: '', rowGroups }],
  };
}

export function makeBaremoDoc() {
  const cgCub  = createUid('cg');
  const cgAdi  = createUid('cg');
  const colTope  = createUid('c');
  const colMonto = createUid('c');

  const columnGroups = [
    { id: cgCub, name: 'Servicios cubiertos',   columns: [{ id: colTope,  name: 'Tope evento anual', align: 'center' }] },
    { id: cgAdi, name: 'Beneficios adicionales', columns: [{ id: colMonto, name: 'Monto en CLP',       align: 'right'  }] },
  ];

  const r = (name, tope = '', monto = '') => ({
    id: createUid('r'), name, cells: { [colTope]: tope, [colMonto]: monto },
  });

  const cubiertos = [
    { id: createUid('rg'), name: 'Primeras visitas', rows: [
      r('Diagnóstico y plan de tratamiento', 'Sin tope'),
      r('Controles de diagnóstico semestrales', '2'),
      r('Interconsulta con especialistas', 'Sin tope'),
      r('Consulta de urgencia', 'Sin tope'),
      r('Control niño sano (6 meses hasta 12 años)', 'Sin tope'),
    ]},
    { id: createUid('rg'), name: 'Odontología preventiva', rows: [
      r('Destartraje supragingival boca completa', '1'),
      r('Profilaxis o pulido coronario', '1'),
      r('Instrucción de higiene oral', 'Sin tope'),
    ]},
    { id: createUid('rg'), name: 'Radiología', rows: [
      r('RX periapical', 'Sin tope'),
      r('RX aleta de mordida bilateral adulto', 'Sin tope'),
      r('RX panorámica', '1'),
      r('Telerradiografía lateral o frontal de cráneo', '1'),
      r('Informes radiológicos', '2'),
    ]},
    { id: createUid('rg'), name: 'Obturaciones', rows: [
      r('Obturación provisoria (1 vez por pieza dental)', 'Sin tope'),
      r('Ajuste oclusal', 'Sin tope'),
      r('Desgaste selectivo', 'Sin tope'),
    ]},
    { id: createUid('rg'), name: 'Endodoncias', rows: [
      r('Interconsulta y control de la especialidad endodóntica', 'Sin tope'),
      r('Diagnóstico pulpar', 'Sin tope'),
      r('Control alta endodóntica (incluye RX)', 'Sin tope'),
    ]},
    { id: createUid('rg'), name: 'Periodoncia', rows: [
      r('Interconsulta y control de la especialidad', 'Sin tope'),
      r('Examen periodontal (incluye sondaje)', 'Sin tope'),
    ]},
    { id: createUid('rg'), name: 'Ortodoncia', rows: [
      r('Interconsulta especialidad ortodoncia', 'Sin tope'),
      r('Estudio clínico y plan de tratamiento', 'Sin tope'),
      r('Set fotográfico', 'Sin tope'),
    ]},
    { id: createUid('rg'), name: 'Implantología', rows: [
      r('Diagnóstico y plan de tratamiento', 'Sin tope'),
      r('Control de la especialidad', 'Sin tope'),
      r('Cirugía de conexión de implante', 'Sin tope'),
    ]},
    { id: createUid('rg'), name: 'Odontopediatría', rows: [
      r('Diagnóstico y plan de tratamiento odontopediátrico', 'Sin tope'),
      r('Controles de diagnóstico semestrales', 'Sin tope'),
      r('Higiene y profilaxis en niños', '1'),
    ]},
    { id: createUid('rg'), name: 'Cirugía oral · exodoncias', rows: [
      r('Control post-quirúrgico con o sin retiro de puntos', 'Sin tope'),
      r('Exodoncia simple piezas temporales', 'Sin tope'),
      r('Exodoncia simple pieza compromiso periodontal', 'Sin tope'),
    ]},
    { id: createUid('rg'), name: 'Urgencias', rows: [
      r('Tratamiento farmacológico (no incluye medicamentos)', 'Sin tope'),
    ]},
  ];

  const adicionales = [
    { id: createUid('rg'), name: 'Odontología preventiva', rows: [
      r('Aplicación de flúor barniz', '', '$28.440'),
      r('Aplicación sellante fotocurado pieza definitiva', '', '$23.640'),
      r('Destartraje supragingival boca completa', '', '$19.080'),
      r('Profilaxis o pulido coronario', '', '$19.080'),
    ]},
    { id: createUid('rg'), name: 'Radiología', rows: [
      r('Radiografía periapical total', '', '$26.352'),
      r('Radiografía panorámica (segunda en el año)', '', '$18.000'),
      r('Cone Beam 1 pieza', '', '$33.000'),
      r('Cone Beam arcada', '', '$39.600'),
      r('Cone Beam bimaxilar', '', '$59.760'),
    ]},
    { id: createUid('rg'), name: 'Obturaciones', rows: [
      r('Restauraciones clase I (anterior y posterior)', '', '$28.380'),
      r('Restauraciones clase II posterior simple', '', '$38.016'),
      r('Restauraciones clase III anterior', '', '$42.900'),
      r('Carillas directas', '', '$78.936'),
    ]},
    { id: createUid('rg'), name: 'Cirugía oral · exodoncias', rows: [
      r('Exodoncia simple', '', '$31.020'),
      r('Exodoncia a colgajo', '', '$41.448'),
      r('Exodoncia 3.er molar superior semi-incluido o incluido', '', '$92.196'),
      r('Exodoncia 3.er molar inferior incluido', '', '$92.196'),
      r('Frenectomía', '', '$54.000'),
    ]},
    { id: createUid('rg'), name: 'Implantología', rows: [
      r('Injerto óseo 0,5 cc (insumo clínico)', '', '$146.280'),
      r('Membrana colágeno 15×25 mm (insumo clínico)', '', '$146.280'),
      r('Implante óseo integrado semi-cónico', '', '$124.560'),
      r('Implante óseo integrado cónico', '', '$124.560'),
    ]},
  ];

  return {
    title: 'Baremo dental 2026',
    eyebrow: 'Beneficios dental',
    subtitle: 'Servicios odontológicos cubiertos y beneficios adicionales · cobertura nacional',
    footnotes: [
      '"Servicios y prestaciones cubiertos" indica el número máximo de prestaciones por asegurado/a en el año calendario. "Sin tope" significa cobertura sin límite de eventos.',
      '"Beneficios adicionales" corresponden al monto reembolsable en pesos chilenos (CLP), complementando los topes anuales.',
    ],
    columnGroups,
    superGroups: [
      { id: createUid('sg'), name: 'Servicios y prestaciones cubiertos', rowGroups: cubiertos  },
      { id: createUid('sg'), name: 'Beneficios adicionales (CLP)',        rowGroups: adicionales },
    ],
  };
}

export function makeBlankDoc() {
  const cgId = createUid('cg');
  const colA  = createUid('c');
  const colB  = createUid('c');
  return {
    title: 'Nuevo cuadro de coberturas',
    eyebrow: 'Cuadro de coberturas',
    subtitle: '',
    columnGroups: [{
      id: cgId,
      name: 'Cobertura',
      columns: [
        { id: colA, name: 'Bono',          align: 'center' },
        { id: colB, name: 'Libre elección', align: 'center' },
      ],
    }],
    superGroups: [{
      id: createUid('sg'),
      name: '',
      rowGroups: [{
        id: createUid('rg'),
        name: 'General',
        rows: [{ id: createUid('r'), name: 'Primera prestación', cells: { [colA]: '', [colB]: '' } }],
      }],
    }],
    footnotes: [],
  };
}

export const PRESET_ORDER = [
  { id: 'complementario', label: 'Plan Complementario · Divina' },
  { id: 'baremo',         label: 'Baremo dental 2026' },
];

export function getPreset(id) {
  if (id === 'complementario') return makePlan(60);
  if (id === 'baremo')         return makeBaremoDoc();
  if (id === 'plan50')         return makePlan(50);
  if (id === 'plan60')         return makePlan(60);
  if (id === 'plan70')         return makePlan(70);
  return makeBlankDoc();
}
